<style scoped>
table{width: 100%;border-top:1px solid #808695;border-left:1px solid #808695;border-spacing:0;background-color:#fff;width:100%}
table td{border-bottom:1px solid #808695;border-right:1px solid #808695;font-size:13px;padding:5px}
.font0{color:rgb(0, 0, 0);}
.imsdf{
  position: relative;
  top:6px;
  margin-right: 3px;
}
.wods img{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>

<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row :gutter="16">
          <Col span="9">
            <Button type="primary" @click="m2.modal=true">批量上传文件</Button>
            <cite>|</cite>

            <span v-if="power.indexOf(39)!=-1">
              <cite>|</cite>
              <a target="_blank" :href="'/api/ziliao/ziliaoFiles/downFiles?fids='+sels">下载选中文件
                <span v-if="sels.length>0">({{sels.length}})</span>
              </a>
            </span>
          </Col>


          <Col span="4">
            &nbsp;
<!--            <HejiSelect :multiple="false"  @on-change="reload" v-model="serch.heji"/>-->
          </Col>

          <Col span="4">
            &nbsp;
<!--            <FenleiSelect @on-change="reload" v-model="serch.fenlei" :multiple="false"></FenleiSelect>-->
          </Col>

          <Col span="7">
             <Input search enter-button placeholder="输入资料名称、编号搜索" v-model="serch.key"  @on-search="reload"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%"  @selection-change="changeFun1">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column prop="id" label="编号" width="60"></el-table-column>
<!--        <el-table-column prop="fid" label="关联文件" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="name" label="资料名称" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <img class="imsdf" :src="'/static/ext/'+scope.row.type+'.png'" style="width:20px;"/>
            <a :href="'/api/upload/download?fid='+scope.row.fid">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="fenleiName" label="分类" width="100" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="day" label="上传日期" width="100" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="downCount" label="下载量" width="80" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="ctime" label="创建时间" width="120" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100,1000]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="文件信息修改"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
				<FormItem label="资料名称" required>
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="上传日期" required>
          <DateSelect v-model="detail.day"></DateSelect>
				</FormItem>
				<FormItem label="预览量" required>
					<Input type="number" v-model="detail.showCount"/>
				</FormItem>
				<FormItem label="下载量" required>
					<Input type="number" v-model="detail.downCount"/>
				</FormItem>

        <FormItem label="分类选择">
          <FenleiSelect v-model="m2.fenleis"></FenleiSelect>
          <span style="color: orange" >
            你当前正在修改合集信息，分类若不需修改，可直接忽略此项，若需修改直接选择修改后的分类即可。
          </span>
        </FormItem>

      </Form>
    </Modal>

    <Modal
      v-model="m2.modal"
      title="批量上传文件"
      @on-ok="save"
      width="650"
    :mask-closable="false">
      <div v-show="m2.current==1">
        <Button v-if="m2.list.length>0" type="error" @click="clear" style="margin-bottom: 8px;">清空已上传的文件</Button>

        <UploadBuch v-model="m2.list"></UploadBuch>

        <p style="text-align: center;font-weight: bold;color: orange">仅支持以下格式：xls/x、ppt/x、doc/x、pdf、zip</p>
      </div>

<!--      设置文件名，下载量相关信息-->
      <div v-if="m2.current==2">
        <Button style="margin-bottom: 10px" type="info" @click="genRandom">随机生成下载量</Button>
        下载量随机区间：
        <input type="number" v-model="m2.min" style="width: 60px"/>~
        <input type="number" v-model="m2.max" style="width: 60px"/>
        <table>
          <tbody>
          <tr style="font-weight: bold">
            <td>资料类型</td>
            <td>资料名称</td>
            <td>上传日期</td>
            <td style="width: 90px">下载量</td>
          </tr>
          <tr v-for="item in m2.subList">
            <td style="text-align: center">
              <img :src="'static/ext/'+item.type+'.png'" style="width: 40px"/>
            </td>
            <td><Input v-model="item.name"/></td>
            <td style="width: 120px">
              <DateSelect v-model="item.day"></DateSelect>
            </td>
            <td >
              <Input type="number" v-model="item.downCount"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

<!--    选择合集或分类 -->
      <div v-if="m2.current==3">
        <Form :label-width="100">
          <FormItem label="分类选择" required>
            <FenleiSelect v-model="m2.fenleis"></FenleiSelect>
            分类是必填项
          </FormItem>
        </Form>
      </div>

      <div slot="footer">
        <span style="padding-right: 10px;">已上传<b>{{m2.list.length}}</b>个文件</span>
        <Button @click="m2.modal=false;">取消</Button>

        <Button @click="m2.current = m2.current-1" :disabled="m2.current<=1" type="info">上一步</Button>
        <Button @click="xiayibu" type="success" :disabled="m2.list.length==0" v-if="m2.current==1">下一步</Button>
        <Button @click="m2.current=3" type="success" :disabled="m2.list.length==0" v-if="m2.current==2">下一步</Button>
        <Button  v-if="m2.current==3" type="primary" @click="submit" :loading="m2.loading">提交</Button>
      </div>
    </Modal>

    <Drawer title="部分预览" width="750" v-model="m4.modal">
      <div v-for="item in m4.list" class="wods">
        <img :src="'/api/upload/ziliao?fid='+m4.fid+'&fname='+item" style="width: 100%"/>
      </div>
      <Alert banner type="warning" style="margin-top: 8px;">
        免费版部分预览说明：word最多支持预览前3页、Excel前3个Sheet，ppt前10页，若需更多预览，请使用全部预览功能。
      </Alert>
    </Drawer>

    <Modal title="ZIP预览"  v-model="m5.modal" draggable>
      <el-table :data="m5.list" size="small" style="width: 100%" >
          <el-table-column prop="name" label="资料名称" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <img class="imsdf" :src="'/static/ext/'+scope.row.type+'.png'" style="width:20px;"/>
              {{scope.row.name}}
            </template>
          </el-table-column>
        <el-table-column prop="gen" label="部分预览图" width="80" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <span v-if="scope.row.gen==0">未生成</span>
            <a @click="show4(scope.row.fid)" v-if="scope.row.gen==1" style="color: #19be6b;font-weight: bold">点击查看</a>
            <span v-if="scope.row.gen==2" style="color: red">生成失败</span>
          </template>
        </el-table-column>
      </el-table>

    </Modal>

  </div>
</template>

<script>
  import UploadBuch from '@/public/upload/UploadBuch'
  import DateSelect from "../../public/iview/DateSelect";
  import HejiSelect from "./common/HejiSelect";
  import FenleiSelect from './common/FenleiSelect'
  export default {
    components:{UploadBuch,DateSelect,HejiSelect,FenleiSelect},
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/ziliao/ziliaoFiles/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:'',
          fenlei:0,
          heji:0,
          gen:0,
        },
        loading:false,
        m2:{ //批量上传文件
          current:1,
          modal:false,
          list:[],//上传的文件列表
          subList:[],//需要提交的文件列表

          hejis:[],//选择的合集
          fenleis:[],//选择的分类

          min:5,
          max:20,//随机数区间
          loading:false,
        },

        m3:{
          modal:false,
        },
        m4:{//部分预览
          modal:false,
          list:[],
          fid:0,
        },
        m5:{//zip压缩包预览
          modal:false,
          list:[]
        },
        day:'',
        sels:[]
      }
    },
    methods:{
      changeFun1(val) { //节点选择改变
        this.sels = [];
        for(let i=0;i<val.length;i++){
          if(this.sels.indexOf(val[i].fid)==-1){
            this.sels.push(val[i].fid);
          }
        }
      },
      jiancha(){
        this.$Message.info("已开始检查");
        let that = this;
        this.$axios.get('/api/ziliao/ziliaoFiles/exetu').then(function(rs){
          that.toast(rs.data);
        });
      },
      chongxin(id){
        let that = this;
        this.$axios.get('/api/ziliao/ziliaoFiles/chongxin?id='+id).then(function(rs){
          that.toast(rs.data);
        });
      },
      reload(){
        this.page = 1;
        this.load();
      },
      show5(id){
        let that = this;
        this.$axios.get('/api/ziliao/ziliaoFiles/getByPid?id='+id).then(function(rs){
          that.m5.list = rs.data;
          that.m5.modal = true;
        });
      },
      show4(fid){
        let that = this;
        this.m4.fid = fid;
        this.$axios.get('/api/ziliao/ziliaoFiles/getyulan?fid='+fid).then(function(rs){
          that.m4.list = rs.data;
          that.m4.modal = true;
        });
      },
      submit(){
        let that = this;
        this.m2.loading = true;
        let data = Object.assign({}, this.m2);
        this.$axios({url:this.baseUrl+'submit',method:'post',data:this.m2}).then(function(rs){
          that.toast(rs.data);
          that.m2.loading = false;
          if(rs.data.success){
            that.m2.modal = false;
            //刷新浏览器
            that.$router.go(0);
          }
        });
      },
      clear(){
        this.m2.list = [];
        this.$refs.nius.clearFiles();
        this.$Message.success('清空成功');
      },
      genRandom(){
        for(let i = 0;i<this.m2.subList.length;i++){
          //下载量
          let downCount = this.randomNum(this.m2.min,this.m2.max);
          //预览量
          let showCount = parseInt(this.randomNum(8,10)*downCount);
          this.m2.subList[i].downCount = downCount;
          this.m2.subList[i].showCount = showCount;
        }
        this.$Message.success('生成成功');
      },
      //生成从minNum到maxNum的随机数
      randomNum(minNum,maxNum){
        switch(arguments.length){
          case 1:
            return parseInt(Math.random()*minNum+1,10);
            break;
          case 2:
            return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
            break;
          default:
            return 0;
            break;
        }
      },
      xiayibu(){ //点击下一步
        let fids = [];
        for(let i = 0;i<this.m2.list.length;i++){
          fids.push(this.m2.list[i].subName);
        }
        let that = this;
        this.$axios({url:this.baseUrl+'checkName?names='+fids,method:'post',data:{}}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.m2.current = 2;
          }else{
            return;
          }
        });

        this.m2.subList = [];
        for(let i = 0;i<this.m2.list.length;i++){
          //对文件类型进行判断
          let uuid = this.m2.list[i].uuid;
          let tp = uuid.substring(uuid.lastIndexOf('.')+1,uuid.length);
          let type = '';
          if(tp==='doc'||tp==='docx'){
            type = 'word';
          }
          if(tp==='xls'||tp==='xlsx'){
            type = 'excel';
          }
          if(tp==='ppt'||tp==='pptx'){
            type = 'ppt';
          }
          if(tp==='pdf'){
            type = 'pdf';
          }
          if(tp==='zip'){
            type = 'zip';
          }

          this.m2.subList.push({
            uuid:this.m2.list[i].uuid,
            type:type,
            downCount:0,
            showCount:0,
            fid:this.m2.list[i].id,
            name:this.m2.list[i].subName,
            day:this.day});
        }

      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.name0t.id@like@'+this.serch.key);
        }

        if(this.serch.gen){
          params.push('t.gen@=@'+this.serch.gen);
        }

        if(!this.serch.fenlei){
          this.serch.fenlei = 0;
        }
        if(!this.serch.heji){
          this.serch.heji = 0;
        }


        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='
          +this.page+'&limit='+this.limit
          +'&params='+params
          +'&fenlei='+this.serch.fenlei
          +'&heji='+this.serch.heji
        ).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.fenleis = null;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save?fenleis='+this.m2.fenleis+'&hejis='+this.m2.hejis,method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.day = this.getTime().substring(0,10);
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ziliao/ZiliaoFiles.vue